import React, { useEffect, useState } from "react";
import "./Gallery.css";
import WOW from "wowjs";
import images from "./data";
import {SRLWrapper} from "simple-react-lightbox"

const options = {
  // settings: {
  // 	overlayColor: 'rgb(25, 136, 124)',
  // 	autoplaySpeed: 1500,
  // 	transitionSpeed: 900
  // },
  // buttons: {
  // 	backgroundColor: 'red',
  // 	iconColor: 'rgba(126, 172, 139, 0.8)'
  // },
  // caption: {
  // 	captionColor: '#a6cfa5',
  // 	captionFontFamily: 'Raleway, sans-serif',
  // 	captionFontWeight: '300',
  // 	captionTextTransform: 'uppercase'
  // },
  // progressBar: {
  // 	height: '20px',
  // 	fillColor: 'blue',
  // 	backgroundColor: 'white'
  // }
};

const Gallery = () => {
  useEffect(() => {
    new WOW.WOW({
      live: false,
    }).init();
  }, []);

  const [tag, setTag] = useState("all");
  const [filteredImages, setFilteredImages] = useState([]);

  useEffect(() => {
    tag === "all"
      ? setFilteredImages(images)
      : setFilteredImages(images.filter((image) => image.tag === tag));
  }, [tag]);

  return (
    <div className="bg">
       
      <div className="bg main-gallery wow fadeIn">
      <div class="container" style={{paddingTop:"100px", }}>
                <div
                  class="page-header text-center wow fadeInDown"
                  data-wow-delay="0.4s"
                >
                  <h2 style={{ color: "#292f4d", fontSize:"50px" }}>Gallery</h2>
                  <div class="devider"></div>
                </div>
              </div>
        <div className="tags">
          <TagButton
            name="all"
            tagActive={tag === "all" ? true : false}
            handleSetTag={setTag}
          />{" "}
          /
          <TagButton
            name="residential"
            tagActive={tag === "residential" ? true : false}
            handleSetTag={setTag}
          />{" "}
          /
          <TagButton
            name="commercial"
            tagActive={tag === "commercial" ? true : false}
            handleSetTag={setTag}
          />{" "}
          /
          <TagButton
            name="roof"
            tagActive={tag === "roof" ? true : false}
            handleSetTag={setTag}
          />
          <TagButton
            name="waterproofing"
            tagActive={tag === "waterproofing" ? true : false}
            handleSetTag={setTag}
          />
        </div>
        <div>
          <SRLWrapper>
          <div className="container-gallery">
            {filteredImages.map((image) => (
              <div key={image.id} className="image-card wow wobble">
                <a href={`./img/${image.imageName}`}>
                  <img
                    className="image"
                    src={`./img/${image.imageName}`}
                    alt=""
                  />
                </a>
              </div>
            ))}
          </div>
          </SRLWrapper>
        </div>
      </div>
    </div>
  );
};

const TagButton = ({ name, handleSetTag, tagActive }) => {
  return (
    <button
      className={`tag ${tagActive ? "active-g" : null}`}
      onClick={() => handleSetTag(name)}
    >
      {name.toUpperCase()}
    </button>
  );
};
export default Gallery;
